class Manager {
    name;
    roles;
    constructor(response) {
        this.name = response.name;
        this.roles = response.roles;
    }
}
export default Manager;
